import moduleLayout from "@/view/bankAc/layout.vue";

export default {
    path: "/order",
    component: moduleLayout,
    redirect: "/order/list",
    name: "OrderCenter",
    children: [
        {
            path: "list",
            name: "OrderList",
            component: () => import("@/view/order/orderlist/index.vue")
        },
        {
            path: "detail",
            name: "OrderDetail",
            component: () => import("@/view/order/orderdetail/index.vue")
        },
        {
            path: "tracking",
            name: "OrderTracking",
            component: () => import("@/view/order/ordertracking/index.vue")
        },
        {
            path: "follow",
            name: "OrderFollow",
            component: () => import("@/view/order/orderfollow/index.vue")
        },
        {
            path: "service/follow",
            name: "OrderServiceFollow",
            component: () => import("@/view/order/servicefollow/index.vue")
        },
        //order/service/follow_starter  order/service/follow_labex  order/service/follow_njuniv  order/service/follow_absin
        {
            path: "service/follow_starter",
            name: "OrderServiceFollowStarter",
            component: () => import("@/view/order/servicefollow/starter.vue")
        },
        {
            path: "service/follow_labex",
            name: "OrderServiceFollowLabex",
            component: () => import("@/view/order/servicefollow/labex.vue")
        },
        {
            path: "service/follow_njuniv",
            name: "OrderServiceFollowNjuniv",
            component: () => import("@/view/order/servicefollow/njuniv.vue")
        },
        {
            path: "service/follow_absin",
            name: "OrderServiceFollowAbsin",
            component: () => import("@/view/order/servicefollow/absin.vue")
        },
        {
            path: "service/follow_absin_search",
            name: "OrderServiceFollowAbsinSearch",
            component: () => import("@/view/order/servicefollow/absin_search.vue")
        },
        {
            path: "self_brand/follow",
            name: "SelfBrandFollow",
            component: () => import("@/view/order/servicefollow/self_brand.vue")
        },
        {
            path: "/oms/starter/kit/order",
            name: "StarterKitOrder",
            component: () => import("@/view/factory/starter_kit_order"),
            meta: { title: "斯达特试剂盒订单列表"}
        },
    ]
};



// WEBPACK FOOTER //
// ./src/router/modules/order.js